module.exports = __webpack_public_path__ + "img/wordSearchRe.22400b6b.svg";